import React from 'react';
import { StarField } from './StarField';
import { BottomNav } from './BottomNav';
export function AppShell({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="relative min-h-screen w-full bg-ink font-sans text-white" data-id="element-23" data-mp="12fm8j6q6529x">
      <StarField data-id="element-24" data-mp="nmj1vue488xz" />
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-app flex-col sm:border-x sm:border-white/[0.06]" style={{
      boxShadow: '0 0 120px -40px rgba(139,92,246,0.35)'
    }} data-id="element-25" data-mp="nn2eqwows755">
        <main className="flex-1 px-5 pb-32 pt-7" data-id="element-26" data-mp="1l86wc9r0gh6v">{children}</main>
      </div>
      <BottomNav data-id="element-27" data-mp="1lajdwlsuwpje" />
    </div>;
}